<template>
    <div class="section" key="redlightAccusationRisk">
        <div class="section-title">
            <div class="author"><img width="50" height="50" src="@/assets/images/rabier.png"></div>
            <h3>Haben Sie andere Verkehrsteilnehmer gefährdet?</h3>
            <p>Bitte prüfen Sie den Bescheid: Sind Sie innerhalb oder außerhalb geschlossener Ortschaften geblitzt worden?</p>
        </div>
        <div class="form-container">
            <div class="form-card">
            <input type="radio" v-model="user.redlightAccusationRisk" name="radio-3" value="Ja" id="question-9-1">
            <label for="question-9-1" v-on:click="incrementChecked()"><span class="label-icon"><img src="@/assets/images/icons8-checked.svg"></span><span>Ja</span></label>
            </div>
            <div class="form-card">
            <input type="radio" v-model="user.redlightAccusationRisk" name="radio-3" value="Nein" id="question-9-2">
            <label for="question-9-2" v-on:click="incrementChecked()"><span class="label-icon"><img src="@/assets/images/icons8-cancel.svg"></span><span>Nein</span></label>
            </div>
            <div class="form-card">
            <input type="radio" v-model="user.redlightAccusationRisk" name="radio-3" value="unsicher" id="question-9-3">
            <label for="question-9-3" v-on:click="incrementChecked()"><span class="label-icon"><img src="@/assets/images/icons8-ask-question.svg"></span><span>Weiß nicht genau</span></label>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'RedlightAccusationRisk',
  computed: mapState({
    user: (state) => state.user,
    checked: (state) => state.checked
  }),
  methods: {
    ...mapMutations([
      'incrementChecked'
    ]),
  }
}
</script>